(function() {
    'use strict';

    angular
        .module('c3WebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('access-token', {
            parent: 'entity',
            url: '/access-token?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'c3WebApp.accessToken.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/access-token/access-tokens.html',
                    controller: 'AccessTokenController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('accessToken');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('access-token-detail', {
            parent: 'access-token',
            url: '/access-token/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'c3WebApp.accessToken.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/access-token/access-token-detail.html',
                    controller: 'AccessTokenDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('accessToken');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AccessToken', function($stateParams, AccessToken) {
                    return AccessToken.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'access-token',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('access-token-detail.edit', {
            parent: 'access-token-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/access-token/access-token-dialog.html',
                    controller: 'AccessTokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccessToken', function(AccessToken) {
                            return AccessToken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('access-token.new', {
            parent: 'access-token',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/access-token/access-token-dialog.html',
                    controller: 'AccessTokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('access-token', null, { reload: 'access-token' });
                }, function() {
                    $state.go('access-token');
                });
            }]
        })
        .state('access-token.edit', {
            parent: 'access-token',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/access-token/access-token-dialog.html',
                    controller: 'AccessTokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AccessToken', function(AccessToken) {
                            return AccessToken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('access-token', null, { reload: 'access-token' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('access-token.delete', {
            parent: 'access-token',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/access-token/access-token-delete-dialog.html',
                    controller: 'AccessTokenDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AccessToken', function(AccessToken) {
                            return AccessToken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('access-token', null, { reload: 'access-token' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
